import { Injectable } from '@angular/core';
import { Request, XHRBackend, RequestOptions, Response, Http, RequestOptionsArgs } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/finally';
import { ProgressbarService } from './core/progressbar/progressbar.service';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class CustomHttpService extends Http {

  private texts: {error: string, allowed: string} = {
    error: this.translate.instant('Ошибка'),
    allowed: this.translate.instant('У вас недостаточно прав')
  };

  constructor(
    private backend: XHRBackend,
    private defaultOptions: RequestOptions,
    private progressbar: ProgressbarService,
    private notie: NotificationsService,
    private translate: TranslateService
  ) {
      super(backend, defaultOptions);
  }

  private catchErrors(error) {
    switch (error.status) {
      case 401:
        window.location.replace('/accounts/login/');
        break;
    }
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    this.progressbar.start();
    return super.request(url, options)
      .catch((error: Response) => {
        this.catchErrors(error);
        return Observable.throw(error);
      }).finally(() => {
        this.progressbar.finish();
      });
  }
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/custom-http.service.ts